import { createContext } from '@shared/utils/createContext';
import { GuestSiteEvent } from '../layout.types';

type EventProviderProps = {
  event: GuestSiteEvent;
};

const [EventProvider, useEventProvider] = createContext<EventProviderProps>({
  name: 'EventProvider'
});

export { EventProvider, useEventProvider };
